<template>
    <div class="text-white bg-indigo-500 px-6 py-2.5 sm:px-3.5 sm:before:flex-1">
        <slot />
    </div>
</template>

<script>
export default {
    name: 'AppBanner',
    props: {},
};
</script>
